import { assert } from 'pdfjs-dist';
<template>
  <div class="history-today">
    <nav class="tip-title __fs-15 _fw-500">历史上的今天</nav>
    <ul>
      <li
        v-for="(item, index) in list"
        :key="index"
        @click="cbDetail(item, index)"
      >
        <section
          v-show="open? true: index <= 2"
          class="__flex __flex-vc __flex-cb"
        >
          <div class="time __flex __cor-8">
            <p class="year __fs-16">{{item.year}}</p>
            <p class="day __fs-10">{{item.month}}-{{item.day}}</p>
          </div>
          <div class="news __flex __flex-cb">
            <p class="title __ta-left __fs-17 __ellipsis __line2">{{item.title}}</p>
            <p class="source __ta-left __line1 __cor-8">{{item.source}}</p>
          </div>
          <div class="news-img __ta-right" v-if="item.listImg">
            <van-image
              class="news-icon"
              :src="formatAliyunPath(item.listImg)"
            />
          </div>
        </section>
      </li>
    </ul>
    <van-image
      v-if="list.length > 3"
      @click="changeOpen()"
      class="open-icon"
      :src="require(`@/assets/images/icon/${open? 'up_more': 'down_more'}.png`)"
    />
  </div>
</template>

<script>
import { aliyun } from '@/agent'
export default {
  name: 'HistoryToday',
  props: {
    list: {
      type: Array
    }
  },
  data () {
    return {
      open: false,
    }
  },
  methods: {
    changeOpen () {
      this.open = !this.open
    },
    cbDetail (item) {
      this.$emit('cb-detail', item)
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    },
  }
}
</script>

<style lang="scss" scoped>
.history-today {
  margin-top: 20px;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  position: relative;
  .tip-title {
    padding-left: 8px;
    border-left: 2px solid $main-color;
    color: #282828;
    margin-bottom: 25px;
  }
  ul{
    li {
      margin-bottom: 25px;
      &:last-child {
        // margin-bottom: 25px;
      }
      .time {
        height: 78px;
        flex-direction: column;
        justify-content: start;
        .year {
          align-self: start;
          margin-bottom: 10px;
        }
        .day {
          align-self: start;
        }
      }
      .news {
        width: 100%;
        height: 78px;
        flex-direction: column;
        margin-left: 26px;
        word-break:break-all;
        .source {
          max-width: 122px;
        }
      }
      .news-img {
        margin-left: 34px;
        .news-icon {
          width: 105px;
          height: 78px;
          flex-shrink: 0;
        }
      }
    }
  }
  .open-icon {
    z-index: 2;
    position: absolute;
    bottom: -40px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    width: 32px;
    height: 16px;
    border-radius: 50%;
  }
}
</style>
